import React, { Component } from 'react'

export default class Header extends Component {
    render() {
        var style = {
            marginTop: "10px"
        }

        var headerContainerStyle = {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingLeft: "16px",
            paddingRight: "16px"
        }

        var logoStyle = {
            height: "40px",
            maxWidth: "200px",
            objectFit: "contain",
            marginTop: "10px"
        }

        return (
            <div style={style}>
                <div style={headerContainerStyle}>
                    <h3 style={{marginTop: "8px"}}>{this.props.step ? `Step ${this.props.step} of ${this.props.totalSteps} - ${this.props.title}` : this.props.title}</h3>
                    <img 
                        src="https://possnippetsdev.bloyal.io/Content/Images/logo.png" 
                        alt="Logo" 
                        style={logoStyle}
                    />
                </div>
                <hr className="lineBreak"></hr>
            </div>
        )
    }
}
